import { EntityFields } from '@/entities/utils/types'
import { CashFlowProjection } from './types'

export const CASHFLOW_PROJECTION_FIELD: EntityFields<CashFlowProjection> = {
  ID: 'id',
  ACCOUNT_ID: 'account_id',
  ASSET_ID: 'asset_id',
  DATE: 'date',
  VALUE: 'value',
  DESCRIPTION: 'description',
  REPOSITORY_ID: 'repository_id',
}

export const CASHFLOW_PROJECTION_DEFAULT_DATA: CashFlowProjection = {
  id: '',
  account_id: '',
  asset_id: '',
  date: null,
  value: null,
  description: null,
}

export const CASHFLOW_PROJECTION_FIELD_LABEL = {
  [CASHFLOW_PROJECTION_FIELD.ACCOUNT_ID]: 'Account',
  [CASHFLOW_PROJECTION_FIELD.ASSET_ID]: 'Asset',
  [CASHFLOW_PROJECTION_FIELD.DATE]: 'Date',
  [CASHFLOW_PROJECTION_FIELD.VALUE]: 'Value',
  [CASHFLOW_PROJECTION_FIELD.DESCRIPTION]: 'Description',
}
